import React from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { dumontColors } from "../../colors";

const TypingContainer = styled(Box)(() => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 4,
  ".dumont-typing-dot": {
    width: 6,
    height: 6,
    borderRadius: "50%",
    backgroundColor: dumontColors.gray400,
    animation: "dumontTypingBounce 1.2s infinite ease-in-out both",
  },
  ".dumont-typing-dot:nth-of-type(2)": {
    animationDelay: "0.15s",
  },
  ".dumont-typing-dot:nth-of-type(3)": {
    animationDelay: "0.3s",
  },
  "@keyframes dumontTypingBounce": {
    "0%": {
      transform: "translateY(0)",
      opacity: 0.2,
    },
    "40%": {
      transform: "translateY(-2px)",
      opacity: 1,
    },
    "80%": {
      transform: "translateY(0)",
      opacity: 0.2,
    },
    "100%": {
      transform: "translateY(0)",
      opacity: 0.2,
    },
  },
}));

export default function TypingIndicator() {
  return (
    <TypingContainer aria-label="Dumont is typing">
      <Box className="dumont-typing-dot" />
      <Box className="dumont-typing-dot" />
      <Box className="dumont-typing-dot" />
    </TypingContainer>
  );
}

